// extracted by mini-css-extract-plugin
module.exports = {"root":"_e68b6d","large":"_a31041","iconText":"_2d1ec5"};